import React from 'react';
import { parseCurrencyToNumber, formatCurrency } from '../../../services/RevenueCalculationService';

const CountryHeader = ({ country, clientData, onClose }) => {
  if (!country) return null;
  
  // Simple filtering without useMemo to avoid potential issues - use correct field name
  const countryClients = clientData.filter(client => client.country === country.country);
  
  // Calculate all statistics dynamically from filtered data
  const totalGroups = countryClients.length;
  
  const avgGroupSize = countryClients.length > 0 
    ? Math.round(countryClients.reduce((sum, client) => sum + parseInt(client.group_size || 0), 0) / countryClients.length) 
    : 0;
  
  const smallestGroup = countryClients.length > 0
    ? Math.min(...countryClients.map(client => parseInt(client.group_size || 0)))
    : 0;
    
  const largestGroup = countryClients.length > 0
    ? Math.max(...countryClients.map(client => parseInt(client.group_size || 0)))
    : 0;
  
  const totalParticipants = countryClients.reduce((sum, client) => sum + parseInt(client.group_size || 0), 0);
  
  // Calculate unique managers from filtered data
  const uniqueManagers = [...new Set(countryClients.map(client => client.Manager).filter(Boolean))];
  const managersCount = uniqueManagers.length;
  
  // Calculate revenue statistics using centralized service
  const totalRevenue = countryClients.reduce((sum, client) => {
    return sum + parseCurrencyToNumber(client['Total Revenue']);
  }, 0);
  
  const lastYearRevenue = countryClients.reduce((sum, client) => {
    return sum + parseCurrencyToNumber(client['Last Booking Revenue']);
  }, 0);

  return (
    <div className="sidebar-header">
      <div className="header-title-area">
        <h2>{country.country}</h2>
        <div className="header-stats">
          <div className="header-stat">
            <span className="header-stat-value">{totalGroups}</span>
            <span className="header-stat-label">Groups</span>
          </div>
          <div className="header-stat">
            <span className="header-stat-value">{totalParticipants}</span>
            <span className="header-stat-label">Participants</span>
          </div>
          <div className="header-stat">
            <span className="header-stat-value">{largestGroup}</span>
            <span className="header-stat-label">Largest</span>
          </div>
          <div className="header-stat">
            <span className="header-stat-value">{smallestGroup}</span>
            <span className="header-stat-label">Smallest</span>
          </div>
          <div className="header-stat">
            <span className="header-stat-value">{avgGroupSize}</span>
            <span className="header-stat-label">Average</span>
          </div>
          <div className="header-stat">
            <span className="header-stat-value">{managersCount}</span>
            <span className="header-stat-label">Managers</span>
          </div>
          <div className="header-stat">
            <span className="header-stat-value">{formatCurrency(totalRevenue, { compact: true })}</span>
            <span className="header-stat-label">Total Revenue</span>
          </div>
          <div className="header-stat">
            <span className="header-stat-value">{formatCurrency(lastYearRevenue, { compact: true })}</span>
            <span className="header-stat-label">Last Year Revenue</span>
          </div>
        </div>
      </div>
      <button className="close-btn" onClick={onClose}>×</button>
    </div>
  );
};

export default CountryHeader;
